<!--  评估关系、被评估人 -->
<template>
  <div>
    <div class="gwnl-auto-wrap">
      <div class="mr32">
        <yxt-button
          type="primary"
          @click="addEvalUsers"
        >
          {{$t('pc_gwnl_eval_btn_addTesters'/* 添加测评人员 */)}}
        </yxt-button>
        <yxt-button
          plain
          @click="showImportRelation"
        >
        {{ importBatchTitle }}
        </yxt-button>
        <yxt-button
        :disabled="!multipleSelection.length"
          plain
          @click="batchDeleteRow"
        >
          {{ $t('pc_gwnl_global_batchDelete'/* 批量删除 */) }}
        </yxt-button>
      </div>
      <template v-if="!isOpenEnv">
        <yxt-input
          v-model="pager.keyword" :placeholder="$t('pc_eval_pleaseEnter').d('请输入')" size="small"
          searchable
          clearable
          class="width305"
          @search="getList(1)"
        >
          <yxt-select slot="prepend" v-model="pager.type" size="small" class="w100">
            <yxt-option :label="$t('pc_eval_tip_username_search').d('姓名')" :value="1" />
            <yxt-option :label="$t('pc_eval_tip_position_search').d('岗位')" :value="2" />
          </yxt-select>
        </yxt-input>
      </template>
    </div>
    <div class="select_table_wrap">
      <yxtbiz-eval-evaluator-table
        ref="multipleTable"
        :datas="tableData"
        :loading="loading"
        :validate="validate"
        @selection-change="handleSelectionChange"
        :scene="scene"
        :dataPermissionCode="evaluatorDataPermission"
        :functionCode="functionCode"
        :is-save="true"
        :id="id"
        :isSelfTest="isSelfTest"
        :relationList="relationList"
      />
      <div class="clearfix pb15">
        <yxtbiz-eval-pager
          :total.sync="pager.total"
          :page.sync="pager.offset"
          :limit.sync="pager.limit"
          @pagination="getList"
        />
      </div>
    </div>

    <yxtbiz-eval-import-drawer
      ref="importRelation"
      :title="importBatchTitle"
      :temp-url="tempUrl"
      :import-methods="importMethods"
      @success="getList(1)"
    />
    <yxtbiz-eval-step-footer
      :operation="operation"
      footer-width="960px"
    />
    <yxtbiz-eval-select-thirdparty-user
      :show-model="[1, 4].includes(type)"
      :visible.sync="addUsersVisible"
      :get-list="getUsers"
      :is-peer="showImportButton"
      @selected="handleSelectedUsers"
      :defaultRaw="userListAll"
      :functionCode="functionCode"
      :dataPermissionCode="dataPermissionCode"
    />
  </div>
</template>

<script>
import commonUtil from '../../common-util';
import relationsMixins from './mixins/relations';

const OPERATION_MAP = new Map([
  [1, 'disabled'],
  [2, 'prevDisabled'],
  [3, 'nextDisabled'],
  [4, 'publishDisabled']
]);

export default {
  mixins: [relationsMixins],
  props: {
    purposeId: {
      type: String,
      default: ''
    },
    projectId: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      language: ''
    };
  },

  mounted() {
    this.language = commonUtil.getLanguage();
    this.init();
  },

  methods: {
    setOperateVal(type, val) {
      this.operation[`${OPERATION_MAP.get(type)}`] = val;
    }
  }
};

</script>
<style lang="scss" scoped>
// 按钮筛选器自动换行
.gwnl-auto-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  & > div {
    margin-bottom: 16px;
  }
}
.select_table_wrap {
  padding-bottom: 56px;
}
</style>
